import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useMemo } from "react"

const LOCALES: Record<string, string> = {
  DE: "de-DE",
  EN: "en-US",
  JA: "ja-JP",
}

export function useNumberFormat() {
  const { currentLanguage } = useTranslation()
  const fmt = useMemo(
    () => new Intl.NumberFormat(LOCALES[currentLanguage] ?? "en-US"),
    [currentLanguage],
  )
  return {
    format: (v: number) => fmt.format(v),
    formatOrNull: (v: number | undefined): string | null =>
      v == null ? null : fmt.format(v),
  }
}
